"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserGroup;
(function (UserGroup) {
    UserGroup[UserGroup["NEWUSER"] = 0] = "NEWUSER";
})(UserGroup = exports.UserGroup || (exports.UserGroup = {}));
var GroupPurchaseStatus;
(function (GroupPurchaseStatus) {
    GroupPurchaseStatus[GroupPurchaseStatus["NEW"] = 0] = "NEW";
    GroupPurchaseStatus[GroupPurchaseStatus["PENDING"] = 1] = "PENDING";
    GroupPurchaseStatus[GroupPurchaseStatus["SUCCESS"] = 2] = "SUCCESS";
    GroupPurchaseStatus[GroupPurchaseStatus["FAILED"] = 3] = "FAILED";
    GroupPurchaseStatus[GroupPurchaseStatus["CANCELLED"] = 4] = "CANCELLED";
})(GroupPurchaseStatus = exports.GroupPurchaseStatus || (exports.GroupPurchaseStatus = {}));
var GroupPurchaseUiStatus;
(function (GroupPurchaseUiStatus) {
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["CREATE_SUCCESS"] = 0] = "CREATE_SUCCESS";
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["GROUP_SUCCESS"] = 1] = "GROUP_SUCCESS";
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["GROUP_FAILED"] = 2] = "GROUP_FAILED";
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["JOIN_SUCCESS"] = 3] = "JOIN_SUCCESS";
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["PENDING"] = 4] = "PENDING";
    GroupPurchaseUiStatus[GroupPurchaseUiStatus["TOO_LATE"] = 5] = "TOO_LATE";
})(GroupPurchaseUiStatus = exports.GroupPurchaseUiStatus || (exports.GroupPurchaseUiStatus = {}));
//# sourceMappingURL=group.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/group.js
// module id = 1002
// module chunks = 0